import React, {useEffect} from 'react';

import {convertNodeToElement} from 'react-html-parser';
import {useSelector} from 'react-redux';

import {useAccountSettings} from 'app/settings/api';
import {useAsyncActions} from 'app/utils/redux';
import {serialize} from 'app/utils/request';
import {markAsSafe} from 'app/utils/strings';
import {getMediaOembed} from 'app/video/actions';

import {getRatio, StyledEmbeddedContainerDiv} from '../../EmbeddedObject';
import {NodeType} from '../node-processors-types';

interface Props {
  node: NodeType;
}

export const EmbedlyVideo = ({node}: Props) => {
  const oembed = useSelector((state) =>
    state.videos.getIn([
      'oEmbeds',
      serialize({
        url: node.attribs.href,
      }),
    ])
  );

  const EMBEDLY_KEY = useAccountSettings(undefined, {
    refetchOnMountOrArgChange: 900,
  }).data?.EMBEDLY_KEY;
  const actions = useAsyncActions({
    getMediaOembed: getMediaOembed(EMBEDLY_KEY),
  });

  useEffect(() => {
    const url = node.attribs.href;
    actions.getMediaOembed({
      url,
    });
  }, []);
  if (oembed != null && oembed.type === 'video') {
    const {width, height} = oembed;
    return (
      <StyledEmbeddedContainerDiv
        style={{
          width,
          height,
        }}
      >
        {oembed.html != null ? (
          <div
            className="embedded-obj"
            style={{
              paddingBottom: getRatio(width, height),
            }}
            dangerouslySetInnerHTML={markAsSafe(oembed.html)}
          />
        ) : null}
      </StyledEmbeddedContainerDiv>
    );
  } else if (oembed != null && oembed.type === 'link') {
    return convertNodeToElement(node, 1, () => undefined);
  }

  return convertNodeToElement(node, 1, () => null);
};
